import {
  type CommandProperties,
  createCommand,
} from '@atlassian/rovo-content-bridge-api';

export type ForwardedPointerEventProperties = {
  clientX: number;
  clientY: number;
  button: number;
  buttons: number;
  pointerId: number;
  pointerType: string;
  viewportWidth: number;
  viewportHeight: number;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  metaKey: boolean;
  isInteractiveDbElement?: boolean;
};

export type PointerDownCommandProperties = CommandProperties &
  ForwardedPointerEventProperties;

export const PointerDownCommand = createCommand<PointerDownCommandProperties>(
  'pointer-down-forwarded',
);

export type PointerMoveCommandProperties = CommandProperties &
  ForwardedPointerEventProperties;

export const PointerMoveCommand = createCommand<PointerMoveCommandProperties>(
  'pointer-move-forwarded',
);

export type PointerUpCommandProperties = CommandProperties &
  ForwardedPointerEventProperties;

export const PointerUpCommand =
  createCommand<PointerUpCommandProperties>('pointer-up-forwarded');
